import { memo } from 'react';

import { Spin } from 'antd';
import { isEqual, capitalize } from 'lodash';

import { OpenItemContentPane } from 'common/components/openItem';
import FolderPanel from './panel/FolderPanel';

import { useFolderContentPane } from 'pages/folders/hooks';
import * as getLink from 'utils/common/linkBuilder';

import * as constant from 'static/Constants';

const FolderContentPane = (props) => {
  const {
    setContentPreview,
    onCloseCallbackHandler,
    onOpenEdit,
    selectFolder,
    isOwner,
    setVisible,
    clickEditFolderHandler,
    addDrawerStack,
  } = props;

  const { shortDetail, isLoading, contentPaneType } = useFolderContentPane();

  const getOpenItemConfig = () => {
    const urlPath = getLink.getLinkPathByEntityType(contentPaneType);

    const configsCollection = {
      folder: {
        type: 'FOLDER_CONTENT_PANE',
        name: shortDetail?.folderName,
      },
    };

    const config = configsCollection[contentPaneType];

    return {
      type: constant.OPEN_ITEM.TYPE[config?.type],
      mode: constant.OPEN_ITEM.MODE.VIEW,
      url: `${urlPath}/${shortDetail?.id}`,
      name:
        config?.name ||
        `${capitalize(contentPaneType)} Full View (default view)`,
    };
  };

  const renderContentPane = () => {
    return renderFolderPanel();
  };

  const renderFolderPanel = () => {
    return (
      <FolderPanel
        clickEditFolderHandler={clickEditFolderHandler}
        ownerFolder={(selectFolder || shortDetail) && isOwner}
        loadingDetail={isLoading}
        shortDetail={shortDetail}
        seePreview={(params) => {
          setContentPreview(params);
          addDrawerStack('contentPreview');
        }}
        onClosePanel={() => {
          setVisible(false);
        }}
        onEditClick={onOpenEdit}
      />
    );
  };

  return (
    <OpenItemContentPane
      config={getOpenItemConfig()}
      onClickCloseBtnCallback={onCloseCallbackHandler}
      folderInfo={shortDetail}
    >
      {isLoading || !shortDetail ? (
        <div className='folder-panel__loading-container'>
          <Spin />
        </div>
      ) : (
        renderContentPane()
      )}
    </OpenItemContentPane>
  );
};

const areEqual = (prevProps, nextProps) => {
  // just update when click to edit button to change view to edit mode, that button only clickable when selected folder is editable
  if (
    (prevProps?.shortDetail?.editable === nextProps?.shortDetail?.editable) ===
    true
  ) {
    return false;
  }

  if (!isEqual(prevProps.shortDetail, nextProps.shortDetail)) {
    return false;
  }

  return true;
};

export default memo(FolderContentPane, areEqual);
